import React from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
// @ts-ignore
import { DefaultAvatar } from '@netbasequid/core'
import { useDisplayTheme, useSysTheme } from 'hooks/useUiState'
import { SystemTheme } from 'hooks/useUiState/types'

const Container = styled.div<{ $theme: SystemTheme }>`
  display: flex;
  align-items: center;
  gap: 12px;
  color: ${({ $theme }) => $theme.text.placeholder};
`

const StyledAvatarContainer = styled.div`
  opacity: 0.4;
`

const DeletedPost = () => {
  const { t } = useTranslation()
  const mode = useDisplayTheme()
  const theme = useSysTheme()

  return (
    <Container $theme={theme}>
      <StyledAvatarContainer>
        <DefaultAvatar fontSize={32} mode={mode} />
      </StyledAvatarContainer>
      {t('postDeletedByAuthor')}
    </Container>
  )
}

export default DeletedPost
